import { resolveComponent, markRaw } from 'vue';

export function getLinkTag(linkTag) {
    // In nuxt we must resolve the dynamic component or v-slot won't be available
    // https://github.com/nuxt/nuxt/issues/24874#issuecomment-1875924956
    if (linkTag === 'nuxt-link') {
        const resolved = resolveComponent('nuxt-link');

        if (typeof resolved === 'object') {
            // do not allow a component object to be made reactive
            markRaw(resolved);
        }

        return resolved;
    }

    return linkTag;
}
